export const CHATBOT_REFERENCE_IMAGE_LIMIT = 5;
export const CHATBOT_REFERENCE_IMAGE_MAX_BYTES = 4 * 1024 * 1024;
